import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Edit from '@material-ui/icons/Edit'
import moment from "moment";
import APPCONFIG from "../../constants/Config";
import Send from "@material-ui/icons/Send";
import Checkbox from "@material-ui/core/Checkbox";

export default class Individual_Invoices extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Financials_Invoice._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 16;
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: "Approved/Rejected",
				id: "approved",
				width: 200,
				/** @param {Financials_Object} obj */
				accessor: obj => obj.rejected === true ? 'Rejected' : ( obj.approved === true ? 'Approved' : 'Pending'),
			},
			{
				Header: "Week",
				id: "week_start_date",
				/** @param {Financials_Object} obj */
				accessor: obj => moment(obj.week_start_date).format('MM/DD/YYYY')
			},
			{
				Header: "Base Pay",
				id: "base_pay",
				/** @param {Financials_Object} obj */
				accessor: obj => (obj.base_pay)
			},
			{
				Header: "Commission",
				accessor: "commission",
			},
			{
				Header: "Travel Fee",
				accessor: "gas_credits",
			},
			{
				Header: "Feedback",
				accessor: "feedback",
			},
			{
				Header: "Hardware",
				accessor: "hardware",
			},
			{
				Header: "Bonus",
				id: "bonus",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 100,
				accessor: obj => obj.bonus,
				Cell: props => {
					return (
						<div style={{textAlign: 'center'}}>
							<Checkbox
								checked={!!props.original.bonus}
								disabled={true}
								color={'primary'}
							/>
						</div>
					);
				}
			},
			{
				Header: "Total Pay",
				accessor: "total_pay",
			},
			{
				Header: "Notes",
				accessor: "notes",
				style: {
					whiteSpace: "normal", // Allow text to wrap
					wordWrap: "break-word",
				},
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 60,
				Cell: props => {
					let url = APPCONFIG.settings.apiURL() + '/' + APPCONFIG.settings.apiVersion + "/forms/results/invoice/" + props.original.pkey;

					return (
						<span>
							<Button color="info" size={"sm"} onMouseDown={() => window.open(url, "_blank")} block={true}>
								View
							</Button>
						</span>
					);
				}
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 45,
				Cell: props => {
					return (
						<span>
							<Button color="green-meadow" size={"sm"} onMouseDown={(event) => {
								if(typeof this.props.handleTabChange === 'function'){
									this.props.handleTabChange(event, 'invoice', () => {
										this.props.history.push({
											pathname: '/pay_center',
											hash: '#invoice?pkey=' + props.original.pkey
										});
									})
								}
							}} block={true}>
								<Edit fontSize={'small'}/>
							</Button>
						</span>
					);
				}
			}
		];
		if (APPCONFIG.settings.apiURL().includes('dev.') || APPCONFIG.settings.apiURL().includes('beta.')) {
			//just to make extra sure it's the right person seeing stuff
			columns.push({
				Header: "Name",
				accessor: "users_name",
			})
		}
		return (
			<Card className="pay-center-card">
				<CardContent className="pay-center-card-content">
					<div className="pay-center-table-wrap">
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						defaultPageSize={limit}
						className="-striped -highlight"
						onPageSizeChange={this.onPageSizeChange}
						pageSize={limit}
					/>
					</div>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
